import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-23fbdf45")

_pushScopeId("data-v-23fbdf45")
const _hoisted_1 = {
  key: 0,
  class: "icon",
  "aria-hidden": "true",
  "font-size": "17px"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "icon",
  "aria-hidden": "true",
  "font-size": "16px"
}
const _hoisted_4 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_SidebarItemLink = _resolveComponent("SidebarItemLink")
  const _component__self = _resolveComponent("_self")
  const _component_el_submenu = _resolveComponent("el-submenu")

  return (!_ctx.item.meta || !_ctx.item.meta.hidden)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: [
    _ctx.isCollapse ? 'simple-mode' : 'full-mode',
    { 'first-level': _ctx.isFirstLevel }
  ]
      }, [
        (!_ctx.alwaysShowRootMenu && _ctx.theOnlyOneChild && !_ctx.theOnlyOneChild.children)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              (_ctx.theOnlyOneChild.meta)
                ? (_openBlock(), _createBlock(_component_SidebarItemLink, {
                    key: 0,
                    to: _ctx.resolvePath(_ctx.theOnlyOneChild.path)
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_menu_item, {
                        index: _ctx.resolvePath(_ctx.theOnlyOneChild.path),
                        class: { 'submenu-title-noDropdown': _ctx.isFirstLevel }
                      }, {
                        default: _withId(() => [
                          (_ctx.theOnlyOneChild.meta.icon)
                            ? (_openBlock(), _createBlock("svg", _hoisted_1, [
                                _createVNode("use", {
                                  "xlink:href": _ctx.theOnlyOneChild.meta.icon
                                }, null, 8, ["xlink:href"])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.theOnlyOneChild.meta.title)
                            ? (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.t("route." + _ctx.theOnlyOneChild.meta.title)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["index", "class"])
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createBlock(_component_el_submenu, {
              key: 1,
              index: _ctx.resolvePath(_ctx.item.path)
            }, {
              title: _withId(() => [
                (_ctx.item.meta && _ctx.item.meta.icon)
                  ? (_openBlock(), _createBlock("svg", _hoisted_3, [
                      _createVNode("use", {
                        "xlink:href": _ctx.item.meta.icon
                      }, null, 8, ["xlink:href"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.item.meta && _ctx.item.meta.title)
                  ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.t("route." + _ctx.item.meta.title)), 1))
                  : _createCommentVNode("", true)
              ]),
              default: _withId(() => [
                (_ctx.item.children)
                  ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.item.children, (child) => {
                      return (_openBlock(), _createBlock(_component__self, {
                        key: child.path,
                        item: child,
                        "is-collapse": _ctx.isCollapse,
                        "is-first-level": false,
                        "base-path": _ctx.resolvePath(child.path),
                        class: "nest-menu"
                      }, null, 8, ["item", "is-collapse", "base-path"]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["index"]))
      ], 2))
    : _createCommentVNode("", true)
})